export default __webpack_public_path__ + "static/birthcontrol-f6d3cf0f43087f7c0649d248f02386d4.gif";